import { useState } from "react";

import { Tab } from "@headlessui/react";

import dataTrustpilot from "common/data/trustpilot/data.json";
import useResizeScreenModified from "common/hooks/useResizeScreenModified";

import Img from "components/atoms/Img";
import LinkRouter from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";
import FaqsGroup from "components/molecules/FaqsGroup";
import FormCountries from "components/molecules/FormCountries";
import TabListNew from "components/molecules/TabListNew/index";
import Banner from "components/organisms/Banner/index.js";
import Faqs from "components/organisms/Faqs";
import TrustpilotFeedBack from "components/organisms/TrustpilotFeedBack";

const Component = ({ dataJson }) => {
  const [screen, setScreen] = useState();

  useResizeScreenModified(setScreen);

  return (
    <>
      <Banner
        minHeightBanner="banner-fix-min-h-569"
        wave={
          <div className="col-12 absolute bottom-0 hidden lg:block ">
            <Img
              src="/assets/images/wave/curve_top-wave.svg"
              className="h-full w-full"
              width={516}
              wrapper={{
                className: "w-full h-full",
              }}
              height={420}
              alt="banner-img"
            />
          </div>
        }
        breadcrumbs={dataJson?.breadcrumbs}
        title="Corporate<br/>Secretarial Services"
        leftContent={
          <p className="mb-6 text-center lg:col-11 lg:mb-14 lg:text-left">
            Incorporating your business in another state means getting through
            who-knows-how-many legal gymnastics. BBCIncorp offers tailored and
            modern corporate secretarial services that make sure your company
            stay compliant no matter the destination.
          </p>
        }
        titleProps={{
          className: "banner-default-title mb-6",
          textColor: "banner-title-default-color",
        }}
        leftClassName="lg:col-7"
        rightClassName="lg:col-5"
        rightContent={
          <div
            className={
              "relative bottom-0 h-auto w-full bg-no-repeat lg:absolute lg:w-[666px] "
            }
          >
            <Img
              src="/assets/images/offshore/corporate-secretary/banner-offshore-secretary.png"
              className="h-full w-full"
              wrapper={{
                className: "bbc-banner-image-bottom-0",
              }}
              width={580}
              height={488}
              alt="corporate secretarial service"
            />
          </div>
        }
        bgColor="bg-bbc-country"
      ></Banner>
      <div className="bg-bbc-brand-100 pt-10 lg:pt-20">
        <div className="container">
          <Title className="title-h2 mb-4 text-center text-bbc-brand-800  lg:mb-6 ">
            Stay compliant anywhere, anytime
          </Title>
          <p>
            Our network of professional company secretaries are always ready to
            provide you with bespoke consultation for +15 jurisdictions
            worldwide. They take care of all your compliance related matters so
            you can focus on growing your business.
          </p>
          <div className="mt-10">
            <div className="row items-center justify-between">
              <div className="lg:col-6">
                <Title as="h3" className="bbc-title-30 ">
                  Keeping up with regulatory changes
                </Title>
                <p>
                  Offshore jurisdictions tend to have a more dynamic legal
                  landscape and are therefore more susceptible to change. When
                  that happens, you&lsquo;ll be one of the first to know.
                </p>
              </div>
              <div className="text-center lg:col-6 lg:text-right">
                <Img
                  src="/assets/images/offshore/corporate-secretary/services1-offshore-secretary.png"
                  width={475}
                  height={480}
                  alt="keep up with regulatory changes"
                />
              </div>
            </div>
          </div>
          <div className="mt-10">
            <div className="row flex-col-reverse items-center justify-between lg:flex-row">
              <div className="text-center lg:col-6 lg:text-left">
                <Img
                  src="/assets/images/offshore/corporate-secretary/services2-offshore-secretary.png"
                  width={502}
                  height={460}
                  alt="avoid troubles"
                />
              </div>
              <div className="lg:col-6">
                <Title as="h3" className="bbc-title-30">
                  Avoiding legal trouble
                </Title>
                <p>
                  Not paying a fee or filing a form on time can get your company
                  fined and placed higher on the legislators&lsquo; pecking
                  list. Overtime, these numbers will add up and be detrimenta l
                  to your bottom line.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-10">
            <div className="row items-center justify-between ">
              <div className="lg:col-6">
                <Title as="h3" className="bbc-title-30">
                  Staying compliant all the time
                </Title>
                <p>
                  Although some jurisdictions allow the key personnel (e.g
                  director, shareholder) to also act as a corporate secretary,
                  others don&lsquo;t adopt the same practice and would require
                  you to enlist service from a third-party provider.
                </p>
              </div>
              <div className="text-center lg:col-6 lg:text-right">
                <Img
                  src="/assets/images/offshore/corporate-secretary/services3-offshore-secretary.png"
                  width={504}
                  height={452}
                  alt="stay compliant all the time"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 mb-10 hidden lg:mb-20 lg:block">
        <Img
          src="/assets/images/wave/curve_bot-wave.svg"
          className="h-full w-full"
          width={516}
          height={420}
          wrapper={{
            className: "w-full h-full",
          }}
          alt="banner-img"
        />
      </div>
      <section>
        <div className="container">
          <Title className="title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10">
            Pricing
          </Title>
          <TabListNew
            data={dataJson.dataPricing.data.map((item) => item.tab)}
            activeTab={dataJson.dataPricing.activeTab}
            tabListClass={{
              display: "flex lg:justify-center",
              length: "w-full",
              padding: "px-1 py-3",
              border: "border-0",
              othersClass: "whitespace-nowrap overflow-x-auto mb-6",
            }}
            tabClass={{
              padding: "py-2 px-4 ",
              tabColor:
                "text-bbc-neutral-600 border-bbc-neutral-600 hover:text-bbc-brand-500 hover:border-bbc-brand-500",
              othersClass: "mr-2 last:mr-0 font-medium",
            }}
          >
            <Tab.Panels>
              {dataJson.dataPricing.data.map((item, index) => {
                return (
                  <Tab.Panel
                    className="focus:outline-none focus:outline-0 focus:ring-0"
                    as="div"
                    key={index}
                  >
                    <div className="shadow-bbc-table mt-10 hidden overflow-x-auto rounded-3xl lg:block">
                      <table className=" text-left text-sm text-bbc-gray">
                        <thead className="col-12 bg-bbc-brand-700  text-2xl  text-bbc-white ">
                          <tr>
                            {item.table?.thead?.map((thead, index) => {
                              return (
                                <th
                                  key={index}
                                  className={`${thead.width} py-8 text-center font-semibold`}
                                >
                                  {thead.name}
                                </th>
                              );
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {item.table?.tbody?.map((thead, index) => {
                            return (
                              <tr
                                key={index}
                                className=" bg-bbc-white even:bg-bbc-brand-100"
                              >
                                <th className="w-1/6 px-4 py-6 align-top font-medium text-bbc-brand-700">
                                  {thead.title}
                                </th>
                                <td className="w-4/6 py-6">
                                  <p className="border-x border-bbc-neutral-700 px-6">
                                    {thead.description}
                                  </p>
                                </td>
                                <td className="w-1/6 px-4 py-6 align-top">
                                  {thead.price ? (
                                    thead.price
                                  ) : (
                                    <LinkRouter
                                      href="/contact-us"
                                      className="font-semibold text-bbc-brand-700 "
                                    >
                                      Contact us
                                    </LinkRouter>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-6 block lg:hidden">
                      {item.table?.tbody?.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="mb-4  rounded-2xl bg-bbc-white shadow-[0_16px_40px_0_rgba(181,181,181,0.25)]"
                          >
                            <h5 className="border-b border-bbc-neutral-500 py-4 text-center font-medium text-bbc-brand-600">
                              {item.title}
                            </h5>
                            <p className="border-b border-bbc-neutral-500 py-6 px-7 text-center">
                              {item.description}
                            </p>
                            <p className="py-4 text-center">
                              {item.price ? (
                                item.price
                              ) : (
                                <LinkRouter
                                  href="/contact-us"
                                  className="font-semibold text-bbc-brand-700 "
                                >
                                  Contact us
                                </LinkRouter>
                              )}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </Tab.Panel>
                );
              })}
            </Tab.Panels>
          </TabListNew>
        </div>
      </section>
      <section>
        <div className="container">
          <Title className="title-h2 mb-4 text-center normal-case text-bbc-brand-800 lg:mb-6">
            Proactive, Professional, and Passionate{" "}
          </Title>
          <p className=" text-center">
            Whatever business you’re doing, be confident you’re in good hands.
          </p>
          <p className="text-center">
            When it comes to corporate secretarial service, you won’t find a
            more committed team.
          </p>
          <div className="row mt-10 justify-center">
            <div className="mt-6 flex items-center lg:col-5 lg:mr-6">
              {screen === "DESKTOP" ? (
                <FaqsGroup data={dataJson.dataProactive} />
              ) : (
                <ul>
                  {dataJson.dataProactive.map((item, index) => (
                    <li key={index} className="mx-4 mb-10 text-center">
                      <div
                        className="mb-4"
                        dangerouslySetInnerHTML={{ __html: item.name }}
                      />
                      <div dangerouslySetInnerHTML={{ __html: item.content }} />
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="order-first lg:col-6 lg:order-last lg:ml-6">
              <Img
                src="/assets/images/offshore/corporate-secretary/service_strong-offshore-secretary.png"
                width={539}
                height={422}
                alt="why choose our service"
              />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="m-auto lg:col-10">
            <Title className="title-h2 mb-4 text-center text-bbc-brand-800 lg:mb-6 lg:text-left ">
              What customers say about BBCIncorp
            </Title>
            <p className="text-center">
              Our skillful secretary have helped thousands of businesses like
              yours with their corporate governance.
            </p>
            <TrustpilotFeedBack data={dataTrustpilot.feedback} />
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="m-auto lg:col-10">
            <Faqs
              // Description="0"
              data={dataJson.dataFaqs}
            />
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="m-auto lg:col-10">
            <FormCountries
              title={dataJson.dataFormContact.title}
              description={dataJson.dataFormContact.description}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Component;
